import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\lenovo\\Desktop\\interio_renov_premium\\interio_renov_premium\\node_modules\\next\\dist\\client\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\lenovo\\Desktop\\interio_renov_premium\\interio_renov_premium\\src\\components\\common\\Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\lenovo\\Desktop\\interio_renov_premium\\interio_renov_premium\\src\\components\\ui\\AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\lenovo\\Desktop\\interio_renov_premium\\interio_renov_premium\\src\\components\\ui\\AppImage.tsx");
